/// <reference path="Utilities/_reference.ts" />

module YVR.Blog {
	// Dependencies
	import i18n = YVR.Utilities.I18n;
	import logger = YVR.Utilities.Logger;

	// CSS Classes
	const classes = {
		block: 'yvr-blog-listing',
		body: 'yvr-blog__body',
		morebutton: 'yvr-blog-listing__morebutton',
		moreBlock: 'yvr-article-listing__more-block',
		moreBlockHidden: 'yvr-article-listing__more-block--hidden'
	};

	// Cached jQuery elements
	const elements = {
		block: $(`.${classes.block}`)
	};

	const odataUrl = elements.block.attr('data-odata-url');

	// Default options
	const options = {
		category: null,
		error: null,
		isEmpty: null,
		isListAll: true,
		pageSize: 10,
		serviceUrl: odataUrl,
		topic: null
	};

	// Cached data calls
	let cache = [];

	let currentPage = 0;

	let preLoad = 0;
	let lastMonthIndex = 0;
	let lastPost;
	function main() {
		const categoryMatch = window.location.href.match('^.+\/categories\/(.+)$');

		if (categoryMatch) {
			options.category = categoryMatch[1];
			options.isListAll = false;
		}

		const topicsMatch = window.location.href.match('^.+\/topics\/(.+)$');

		if (topicsMatch) {
			options.topic = topicsMatch[1];
			options.isListAll = false;
		}

		// Add initial blank table to page
		renderBlog(options);

		runBlog();

		elements.block.on('click', `.${classes.morebutton}`, function () {
			runBlog();
		});
	}

	//#region Blog

	/**
	 * Get and render the blog listing, removing any previous
	 */
	function runBlog() {
		if (elements.block.length) {
			currentPage++;

			const odataFilter = elements.block.attr('data-odata-filter');

			getBlog(options.category, options.topic, odataFilter, currentPage)
				.then(checkForNoMore)
				.then(appendDataToCache)
				.then(transformBlogData)
				.then(renderBlog)
				.then(focusBlog)
				.fail(() => {
					console.error('[blog][runBlog] An error occured retrieving the blog data.');

					options.error = true;
					options.isEmpty = false;

					renderBlog(options);
				});
		}
	}


	/**
	 * Get the blog data from the blog service.
	 * @returns {obj} A jQuery promise that resolves with data from the blog service.
	 */
	function getBlog(category: string, topic: string, filter: string, page: number): JQueryPromise<any> {
		const data: any = {
			'$orderby': 'Published desc',
			'$top': options.pageSize
		};

		if (filter) {
			data.$filter = filter;
		} else if (category) {
			data.$filter = `PostTypeCode eq '${decodeURIComponent(category)}'`;
		} else if (topic) {
			data.$filter = `PostTopicCodes/any(topic: tolower(topic) eq tolower('${decodeURIComponent(topic)}'))`;
		}

		if (page) {
			data.$skip = (page - 1) * options.pageSize;
		}

		return $.get({
			url: options.serviceUrl,
			data,
			success() {
				logger.log('[blog][getBlog] Successfully retrieved blog data.');
			}
		});
	}


	/**
	 * Hides the more button if a full page of items weren't returned.
	 * @returns {obj} A jQuery promise that resolves with original data.
	 */
	function checkForNoMore(data: any) {
		if (data.value.length < options.pageSize) {
			elements.block.find(`.${classes.moreBlock}`).remove();
		} else {
			elements.block.find(`.${classes.moreBlock}`).removeClass(classes.moreBlockHidden);
		}

		return data;
	}


	/**
	 * Appends the data just fetched to the local cache.
	 * @returns {obj} A jQuery promise that resolves with entire cached data.
	 */
	function appendDataToCache(data) {
		// Keep this data as cached
		cache = $.merge(cache, data.value);

		return cache;
	}


	/**
	 * Transform the data from the web service to be more user and template friendly.
	 * @returns {obj} A jQuery promise that resolves with transformed blog data.
	 */
	function transformBlogData(data: any[]) {
		const model = {
			Months: [],
			IsListAll: options.isListAll
		};

		// Loop through each blog item
		for (let i = 0; i < data.length; i++) {
			const blogItem = data[i];
			const published = new Date(blogItem.Published);
			const m = published.getMonth();
			const y = published.getFullYear();
			const monthName = (window as any).moment.months()[m];

			let month = GetMonthFromArray(model.Months, m, y);

			if (!month) {
				month = {
					MonthName: monthName,
					Month: m,
					Year: y,
					Posts: []
				};

				model.Months.push(month);
			}

			month.Posts.push(blogItem);
		}

		return model;
	}


	/**
	 * Get the month from an array.
	 * @param monthArray
	 * @param month
	 * @param year
	 */
	function GetMonthFromArray(monthArray: any[], month: number, year: number): any {
		let _this;

		$.each(monthArray, function () {
			if (this.Month === month && this.Year === year) {
				_this = this;

				return false;
			}
		});

		return _this;
	}

	/**
	 * Render the blog data using the blog template.
	 */
	function renderBlog(data: any): void {

		let template = null;

		if (document.documentElement.lang === "fr") {
			template = YVR.templates.blogFR;
		} else {
			template = YVR.templates.blogEN;
		}

		const html = template(data);

		// Add the table right before the view all link
		$(`.${classes.body}`).html(html);
	}

	function focusBlog(data: any): void {
		if (preLoad == 1) {
			lastPost = $('.yvr-article-listing__post-title');
			if (lastMonthIndex + 1 <= lastPost.length - 1) {
				let newElement = $(lastPost[lastMonthIndex + 1]);

				$([document.documentElement, document.body]).animate({
					scrollTop: newElement.offset().top
				}, 2000);
				lastMonthIndex = lastPost.length - 1;

			}

		} else {
			lastPost = $('.yvr-article-listing__post-title');
			lastMonthIndex = lastPost.length - 1;
			preLoad = 1;
		}
	}

	//#endregion


	main();
}
